import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { reviews, videoTestimonials } from '../../data/reviews';
import { SITE } from '../../data/site';
import { ReviewCard, Stars, VideoReviewCard } from '../shared/ReviewCard';
import { ButtonLink } from '../ui/ButtonLink';
export function ReviewsSection() {
  const scroller = useRef<HTMLUListElement>(null);
  const scrollBy = (dir: 1 | -1) => {
    const el = scroller.current;
    if (el) el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  return <section className="section bg-white" aria-labelledby="reviews-title" data-id="element-243" data-mp="1tqh65we45ftj">
      <div className="gutter flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-244" data-mp="1os76p9lcvt24">
        <div data-id="element-245" data-mp="ic3mz4ub1oju">
          <h2 id="reviews-title" className="sr-only" data-id="element-246" data-mp="icms1kyuwigg">
            Student reviews
          </h2>
          <div className="flex items-end gap-5" data-id="element-247" data-mp="dda9hcf0pxjo">
            <span className="font-display text-[clamp(5rem,10vw,11rem)] font-bold leading-[0.85] text-navy" data-id="element-248" data-mp="dbpbtdxepyhl">{SITE.googleRating}</span>
            <div className="pb-2" data-id="element-249" data-mp="1cpd3wbib0kye">
              <Stars className="h-6 w-6 lg:h-8 lg:w-8" data-id="element-250" data-mp="1cobt8857a0h7" />
              <p className="mt-2 font-display text-xl uppercase tracking-[0.12em] text-steel" data-id="element-251" data-mp="xs4azddcr94k">on Google</p>
            </div>
          </div>
          <span className="red-rule mt-6" aria-hidden="true" data-id="element-252" data-mp="12q5t9w2yf4ez" />
          <p className="t-lead mt-5 max-w-[40rem] text-steel" data-id="element-253" data-mp="ozsn9z9mhzsa">Thousands of Las Vegas students trust HPP with the skill that matters most.</p>
        </div>
        <div className="flex flex-wrap items-center gap-3" data-id="element-254" data-mp="trakcc8izg7z">
          <ButtonLink to="/reviews" variant="outline-dark" data-id="element-255" data-mp="f24ql3sgii7h">
            Read the Wall of Love
          </ButtonLink>
          <ButtonLink href={SITE.googleReviews} variant="dark" newTab data-id="element-256" data-mp="jzwe7lm2ji5v">
            Leave a Review
          </ButtonLink>
          <div className="ml-2 hidden gap-2 md:flex" data-id="element-257" data-mp="61gbs6v8odtj">
            <button type="button" onClick={() => scrollBy(-1)} aria-label="Previous reviews" className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/20 text-navy hover:border-navy" data-id="element-258" data-mp="a29ywy0uxold">
              <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-259" data-mp="27y6zcwi9fx0y" />
            </button>
            <button type="button" onClick={() => scrollBy(1)} aria-label="Next reviews" className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/20 text-navy hover:border-navy" data-id="element-260" data-mp="22yudadz7qtzf">
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-261" data-mp="2vob3d4zd1ysh" />
            </button>
          </div>
        </div>
      </div>
      <ul ref={scroller} className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto bg-white px-[clamp(1rem,4vw,7rem)] pb-4 [scroll-padding-inline:clamp(1rem,4vw,7rem)]" aria-label="Testimonials" data-id="element-262" data-mp="2qphop98c81qq">
        {reviews.map(r => <li key={r.id} className="w-[min(88vw,30rem)] shrink-0 snap-start 3xl:w-[34rem]" data-id="element-263" data-mp="1abrgpre3ktbt">
            <ReviewCard review={r} data-id="element-264" data-mp="168v3kg7btpf9" />
          </li>)}
        <li className="w-[min(88vw,30rem)] shrink-0 snap-start 3xl:w-[34rem]" data-id="element-265" data-mp="3hwgi2nijgweg">
          <VideoReviewCard video={videoTestimonials[0]} data-id="element-266" data-mp="3hudibbrl3owj" />
        </li>
        <li className="flex w-[min(88vw,22rem)] shrink-0 snap-start flex-col justify-center rounded-[4px] bg-navy p-8" data-id="element-267" data-mp="3lyv055edvs4o">
          <p className="font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-268" data-mp="3qvtv1q5vg33x">Trained with us?</p>
          <p className="mt-2 text-chrome-300" data-id="element-269" data-mp="3vpy209f50b50">Your story helps someone take their first step.</p>
          <Link to="/reviews" className="mt-6 inline-flex items-center gap-2 font-semibold text-white underline underline-offset-4" data-id="element-270" data-mp="4jo7fq4jndz7">
            See every review <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="di08km31du5w" />
          </Link>
        </li>
      </ul>
    </section>;
}